var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FontAwesomeIcon',{attrs:{"icon":[_vm.type, _vm.icon],"border":_vm.border,"fixedWidth":_vm.fixedWidth,"flip":_vm.flip,"mask":_vm.mask,"listItem":_vm.listItem,"pull":_vm.pull,"pulse":_vm.pulse,"rotation":_vm.rotation,"size":_vm.size,"spin":_vm.spin,"transform":_vm.transform,"symbol":_vm.symbol}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-655e79cd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","ParallaxImage":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FA.vue
// module id = null
// module chunks = 